import React, { useState } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import _isEmpty from "lodash/isEmpty"
import _map from "lodash/map"
import _filter from "lodash/filter"

import ModernModal from "shared/components/ModernModal"
import Typograph from "../../../../../../components/Typograph"
import Description from "../../../Description"
import Button from "shared/components/Button/Button"
import ModernFloatLabelInput from "shared/components/ModernFloatLabelInput"

import styles from "./styles.css"

import { maskTel, removeMaskTel } from "services/utils/mask"
import { isPhone } from "services/utils/regexForValidations"
import { recalculateRedirectPercentage } from "../../../../helpers"

import DeleteIcon from "../../../../../../assets/svg/icon-delete.svg"

const StepAddNumbers = ({
  isCurrentStep,
  onNextStep,
  onClose,
  t,
  schedule,
  update
}) => {
  const [phoneNumber, setPhoneNumber] = useState("")
  const [schedulingData, setSchedulingData] = useState(schedule.loadRedirect)
  const [isPhoneNumberInvalid, setIsPhoneNumberInvalid] = useState(false)

  const inputClass = classnames({ [styles.inputClass]: isPhoneNumberInvalid })

  const disabledAddButton =
    schedulingData &&
    schedulingData.targetPhoneList &&
    schedulingData.targetPhoneList.length === 4

  const handleChangePhoneNumber = (e) => {
    setPhoneNumber(e.target.value)
    if (isPhoneNumberInvalid) {
      setIsPhoneNumberInvalid(false)
    }
  }

  const handleAddNumber = () => {
    const phoneWithoutMask = removeMaskTel(phoneNumber)

    if (_isEmpty(phoneNumber) || !isPhone(phoneWithoutMask)) {
      setIsPhoneNumberInvalid(true)
      return
    }

    const phoneList = schedulingData.targetPhoneList
      ? [...schedulingData.targetPhoneList, { phoneNumber: phoneWithoutMask }]
      : [{ phoneNumber: phoneWithoutMask }]
    const targetPhoneList = recalculateRedirectPercentage(phoneList)

    setSchedulingData((prevState) => ({
      ...prevState,
      targetPhoneList
    }))

    setPhoneNumber("")
  }

  const handleDeleteNumber = (phone) => {
    const phoneList = _filter(
      schedulingData.targetPhoneList,
      (item) => item.phoneNumber !== phone
    )
    const targetPhoneList = recalculateRedirectPercentage(phoneList)
    setSchedulingData((prevState) => ({
      ...prevState,
      targetPhoneList
    }))
  }

  const handleNextStep = () => {
    update(schedulingData)
    onNextStep()
  }

  return (
    <ModernModal
      isOpen={isCurrentStep}
      onConfirm={handleNextStep}
      onClose={onClose}
      onCancel={onClose}
      cancelButtonText="Sair"
      confirmButtonText="Prosseguir"
      disabled={!schedulingData.targetPhoneList}
    >
      <Typograph htmlTag="h1" size="medium" color="outer_space" weight="bold">
        {t("START_CONFIG")}
      </Typograph>
      <Typograph htmlTag="p" size="medium" color="outer_space" weight="medium">
        {t("CHOOSE_NUMBER_REDIRECT")}
      </Typograph>
      {schedulingData.targetPhoneList && (
        <Description className={styles.descriptionContainer}>
          {_map(schedulingData.targetPhoneList, (item) => (
            <div className={styles.numberItemsClass}>
              <Typograph
                htmlTag="p"
                size="small"
                color="outer_space"
                weight="bold"
              >
                {maskTel(item.phoneNumber)}
              </Typograph>
              <button onClick={() => handleDeleteNumber(item.phoneNumber)}>
                <img src={DeleteIcon} alt="Excluir" />
              </button>
            </div>
          ))}
        </Description>
      )}

      <div className={styles.selectNumberContainer}>
        <ModernFloatLabelInput
          containerClasses={inputClass}
          id="phoneNumber"
          maxLength={15}
          value={maskTel(phoneNumber)}
          label="Qual número você deseja?"
          placeholder="(DDD) + número"
          margin="top_0"
          onChange={(e) => handleChangePhoneNumber(e)}
          error={isPhoneNumberInvalid && "Número de telefone inválido"}
        />
        <Button
          buttonStyle="secondary"
          width="small"
          onClick={handleAddNumber}
          disabled={disabledAddButton}
        >
          Adicionar
        </Button>
      </div>
    </ModernModal>
  )
}

StepAddNumbers.propTypes = {
  isCurrentStep: PropTypes.bool,
  onNextStep: PropTypes.func,
  onClose: PropTypes.func,
  t: PropTypes.func,
  update: PropTypes.func,
  schedule: PropTypes.object
}
export default StepAddNumbers



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/StepModals/components/StepAddNumbers/index.js